<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>商家建档申请</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.sa_id"
                    placeholder="申请单号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.city"
                    placeholder="城市"
                    @change="setMarket"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.father_market_id"
                    filterable
                    placeholder="市场"
                    @change="setChild"
                  >
                    <el-option
                      v-for="item in market"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select
                    v-model="form.market_id"
                    filterable
                    placeholder="子市场"
                  >
                    <el-option
                      v-for="item in child_market"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.brand_name"
                    placeholder="品牌名"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select v-model="form.style" multiple placeholder="主风格">
                    <el-option
                      v-for="item in styles"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_id"
                    placeholder="商家id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.submit_admin"
                    placeholder="提审人"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item v-if="status" label="">
                  <el-select v-model="form.status" multiple placeholder="状态">
                    <el-option
                      v-for="item in status"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="提审时间：">
                  <el-date-picker
                    v-model="form.submit_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="一审时间：">
                  <el-date-picker
                    v-model="form.first_check_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item label="二审时间：">
                  <el-date-picker
                    v-model="form.second_check_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item v-if="status" label="">
                  <el-select
                    v-model="form.show_app"
                    placeholder="是否提前订阅"
                    clearable
                  >
                    <el-option
                      v-for="item in showApp"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item v-if="status" label="">
                  <el-select
                    v-model="form.fans_status"
                    placeholder="粉丝状态"
                    clearable
                  >
                    <el-option
                      v-for="item in fansStatus"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item width="auto">
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button
                    style="background: #85ce61"
                    type="success"
                    @click="output"
                    >导出</el-button
                  >
                  <el-upload
                    style="margin: 0px 10px; display: inline-block"
                    :action="importApi"
                    :show-file-list="false"
                    :auto-upload="true"
                    :on-success="importSupplyApplySuccess"
                    with-credentials
                  >
                    <el-button slot="trigger" type="primary">
                      批量导入建档申请
                    </el-button>
                  </el-upload>
                  <el-button type="success" @click="handleDownExportTemplate">
                    下载导入模版
                  </el-button>
                  <el-button type="primary" @click="handleSupplyMsg()">
                    新增
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              align="center"
              prop="sa_id"
              label="申请单号"
              width="80"
            ></el-table-column>
            <el-table-column
              prop="apply_img"
              label="申请图片"
              show-overflow-tooltip
              align="center"
              width="80"
            >
              <template #default="scope">
                <div
                  v-viewer
                  style="
                    width: 40px;
                    height: 40px;
                    overflow: hidden;
                    cursor: pointer;
                    margin: auto;
                  "
                >
                  <img
                    v-for="(item, key) in scope.row.apply_imgs"
                    :key="key"
                    :src="item"
                    style="max-width: 100%; max-height: 100%"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="license" label="营业执照" align="center">
              <template #default="{ row }">
                <img
                  v-viewer
                  :src="row.license"
                  alt=""
                  style="max-width: 80px; max-height: 80px"
                />
              </template>
            </el-table-column>
            <el-table-column prop="supply_video" label="视频" align="center">
              <template #default="{ row }">
                <video
                  v-if="row.supply_video"
                  :src="row.supply_video"
                  style="max-width: 80px; max-height: 80px"
                  preload="metadata"
                  @click="handleViewVideo(row.supply_video)"
                />
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="city_name"
              label="城市"
              width="80"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="market_name"
              label="市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="child_market_name"
              label="子市场"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="brand_name"
              label="品牌名"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supplier_num"
              label="档口号"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="subscribe_num"
              label="提前订阅粉丝数"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="fans_status_txt"
              label="粉丝状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="show_app"
              label="是否可提前订阅"
              width="100"
            >
              <template #default="scope">
                <el-switch
                  :value="scope.row.show_app"
                  active-value="1"
                  inactive-value="2"
                  @change="handleShowApp(scope.row)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="main_styles"
              label="主风格"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="submit_admin_name"
              label="提审人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="submit_time"
              label="提审时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="submit_reason"
              label="申请原因"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="apply_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_check_admin_name"
              label="一审人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_check_time"
              label="一审时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="first_reject_reason"
              label="一审驳回原因"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_check_admin_name"
              label="二审人"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_check_time"
              label="二审时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="second_reject_reason"
              label="二审驳回原因"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_id"
              label="商家id"
            ></el-table-column>
            <el-table-column
              label="操作"
              align="center"
              fixed="right"
              width="160"
            >
              <template #default="scope">
                <div class="bottom-wrap">
                  <el-button
                    v-if="scope.row.status !== STATUS_TYPE.CANCELLED"
                    class="sub-bottom"
                    size="mini"
                    type="primary"
                    @click="handleSupplyMsg(scope.row)"
                    >提前订阅信息修改
                  </el-button>
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.PENDING_REVIEW_2"
                    size="mini"
                    type="primary"
                    @click="addSupply(scope.row)"
                    >创建商家</el-button
                  >
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.CLOSED"
                    size="mini"
                    type="success"
                    class="sub-bottom"
                    @click="openSupplyApply(scope.row)"
                    >开启档口</el-button
                  >
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.COOPERATING"
                    size="mini"
                    type="danger"
                    class="sub-bottom"
                    @click="closeSupplyApply(scope.row)"
                    >关闭档口</el-button
                  >
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.PENDING_REVIEW_1"
                    size="mini"
                    type="success"
                    class="sub-bottom"
                    @click="firstPass(scope.row)"
                    >通过</el-button
                  >
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.PENDING_REVIEW_1"
                    size="mini"
                    type="danger"
                    class="sub-bottom"
                    @click="firstReject(scope.row)"
                    >驳回</el-button
                  >
                  <el-button
                    v-if="scope.row.status === STATUS_TYPE.UNSUBMITTED"
                    size="mini"
                    type="danger"
                    @click="handleCancellation(scope.row)"
                    >作废申请</el-button
                  >
                  <el-button
                    size="mini"
                    type="text"
                    @click="supplyLog(scope.row)"
                  >
                    日志</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-dialog title="操作日志" :visible.sync="logVisible" width="70%">
            <div v-if="logData">
              <el-table :data="logData.list">
                <el-table-column
                  property="event"
                  label="事件"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="remark"
                  label="内容"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="admin_name"
                  label="操作人"
                  align="center"
                ></el-table-column>
                <el-table-column
                  property="create_time"
                  label="操作时间"
                  align="center"
                ></el-table-column>
              </el-table>
              <div style="text-align: right; padding: 25px">
                <el-pagination
                  :current-page.sync="logcurPage"
                  background
                  layout="total, prev, pager, next, jumper "
                  :total="logData.logpages"
                  :page-size="10"
                  @current-change="handleCurrentChange2"
                ></el-pagination>
              </div>
            </div>
          </el-dialog>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.pages"
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <supply-message-dialog ref="supplyMessageRef" @submit-success="fetchData" />
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";

import { setShowApp } from "@/controller/supplyApply3750.js";

import SupplyMessageDialog from "./components/SupplyMessageDialog.vue";
import * as supplyApplyApi from "@/openapi/erp/SupplyApply.js";

const STATUS_TYPE = {
  CLOSED: "0",
  COOPERATING: "1",
  PENDING: "2",
  PENDING_REVIEW_1: "3",
  PENDING_REVIEW_2: "4",
  REJECTED: "5",
  CANCELLED: "6",
  DRAFT: "7",
  UNSUBMITTED: "8",
};
export default {
  components: { SupplyMessageDialog },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // if (!vm.resData) {
      vm.fetchData();
      // }
    });
  },
  data() {
    return {
      STATUS_TYPE,
      logpages: 0,
      logcurPage: 1,
      supply_ids: [],
      showBind: false,
      logData: [],
      logVisible: false,
      resData: null,
      supply: {
        list: [],
      },
      form: {
        status: "",
        create_time: [],
        supply_id: "",
        sa_id: "",
        set_pgid: "", // 设置的代采组id
        market_id: "全部",
        father_market_id: "全部",
        is_order_ability: "",
        is_all_style: "",
        is_benchmarking: "",
      },
      citys: CITY,
      supply_status: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      settle_type: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "常规代采",
        },
        {
          value: "2",
          label: "先货后款",
        },
      ],
      is_expire: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "未到期",
        },
        {
          value: "2",
          label: "已到期",
        },
      ],
      need_settle_flag: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "已有数据",
        },
        {
          value: "2",
          label: "暂无数据",
        },
      ],
      // 这个反向options 0 是 1否 .. 小心小心小心小心小心小心小心
      is_scal_options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "是",
        },
        {
          value: "1",
          label: "否",
        },
      ],
      public_option: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/SupplyApply/listSupplyApply",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      dialogFormVisible: false,
      memberOption: [],
      defectiveGroupOption: [],
      defectiveGroupMemberOption: [],
      refundMemberOption: [],
      followerOption: [],
      cur_id: 0,
      supply_id: 0,
      showDgBind: false,
      market: [],
      child_market: [],
      floor: [],
      pg_list: [],
      supply_area: [],
      pickers: [],
      pay_method_ops: [],
      sale_levels_ops: [],
      refund_models: [],
      sa_id: 0,
      styles: [],
      status: [],
      fansStatus: [],
      showApp: [],
      supplyForm: {},
      importApi: `${apiBaseURL}/erp/SupplyApply/importData`,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleCancellation(row) {
      const { sa_id: saId } = row;
      this.$confirm(`确认要作废建档申请：${saId}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        supplyApplyApi
          .postDeleteSupplyApply({ sa_id: saId })
          .then(() => {
            this.$message.success("作废成功");
            this.fetchData();
          })
          .catch((err) => {
            this.$message.error(err.msg);
          });
      });
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    bindMember() {
      if (this.supply_ids.length < 1) {
        this.$message.error("请选择商家");
      }
      this.showBind = true;
    },
    bindDgMember() {
      if (this.supply_ids.length < 1) {
        this.$message.error("请选择商家");
      }
      this.showDgBind = true;
    },
    setChild(value) {
      this.form.market_id = "全部";
      this.child_market = [];
      if (value == 0) {
        return;
      }
      this.$http
        .post("/erp/SupplyApply/getChildMarket", { parent_id: value })
        .then((res) => {
          if (res.data.code == 200) {
            this.child_market = res.data.data;
          }
        });
    },
    setMarket(value) {
      this.form.father_market_id = "全部";
      this.market = [];
      if (value == 0) {
        return;
      }
      this.$http
        .post("/erp/SupplyApply/getMainMarket", { city: value })
        .then((res) => {
          if (res.data.code == 200) {
            this.market = res.data.data;
          }
        });
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          // this.market = this.resData.market;
          this.child_market = this.resData.child_market;
          this.styles = this.resData.styles;
          this.status = this.resData.status;
          this.fansStatus = this.resData.fans_status;
          this.showApp = this.resData.show_app;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const temp = val;
      temp.forEach((element) => {
        this.supply_ids.push(element.supply_id);
      });
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    addSupply(row) {
      this.$router.push(`/home/supply/addSupplyByApply/${row.sa_id}`);
    },
    secondReject(row) {
      const { sa_id } = row;
      this.$prompt("", "原因", {
        closeOnClickModal: false,
        inputPlaceholder: "录入原因（必填）",
        inputErrorMessage: "输入不能为空",
        customClass: "secondReject",
        inputType: "textArea",
        area: ["200px", "200px"],
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return "输入不能为空";
          }
        },
      }).then((e) => {
        const { value } = e;
        this.$http
          .post("/erp/supplyApply/secondReject", {
            content: value,
            sa_id,
          })
          .then((rs) => {
            if (rs.data.code != 200) {
              return this.$message.error(rs.data.msg);
            }
            this.fetchData();
            return this.$message.success(rs.data.msg);
          });
      });
    },
    openSupplyApply(row) {
      const { sa_id } = row;
      this.$prompt("", "原因", {
        closeOnClickModal: false,
        inputPlaceholder: "录入原因（必填）",
        inputErrorMessage: "输入不能为空",
        inputType: "textArea",
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return "输入不能为空";
          }
        },
      }).then((e) => {
        const { value } = e;
        this.$http
          .post("/erp/supplyApply/openSupplyApply", {
            remark: value,
            sa_id,
          })
          .then((rs) => {
            if (rs.data.code != 200) {
              return this.$message.error(rs.data.msg);
            }
            this.fetchData();
            return this.$message.success(rs.data.msg);
          });
      });
    },
    closeSupplyApply(row) {
      const { sa_id } = row;
      this.$prompt("", "原因", {
        closeOnClickModal: false,
        inputPlaceholder: "录入原因（必填）",
        inputErrorMessage: "输入不能为空",
        inputType: "textArea",
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return "输入不能为空";
          }
        },
      }).then((e) => {
        const { value } = e;
        this.$http
          .post("/erp/supplyApply/closeSupplyApply", {
            remark: value,
            sa_id,
          })
          .then((rs) => {
            if (rs.data.code != 200) {
              return this.$message.error(rs.data.msg);
            }
            this.fetchData();
            return this.$message.success(rs.data.msg);
          });
      });
    },
    firstReject(row) {
      const { sa_id } = row;
      this.$prompt("", "原因", {
        closeOnClickModal: false,
        inputPlaceholder: "录入原因（必填）",
        inputErrorMessage: "输入不能为空",
        customClass: "secondReject",
        inputType: "textArea",
        area: ["200px", "200px"],
        inputValidator: (value) => {
          // 点击按钮时，对文本框里面的值进行验证
          if (!value) {
            return "输入不能为空";
          }
        },
      }).then((e) => {
        const { value } = e;
        this.$http
          .post("/erp/supplyApply/firstReject", {
            content: value,
            sa_id,
          })
          .then((rs) => {
            if (rs.data.code != 200) {
              return this.$message.error(rs.data.msg);
            }
            this.fetchData();
            return this.$message.success(rs.data.msg);
          });
      });
    },
    firstPass(row) {
      const { sa_id } = row;
      this.$confirm(`是否确定通过申请单：${sa_id}`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$http.post("/erp/supplyApply/firstPass", { sa_id }).then((rs) => {
          if (rs.data.code != 200) {
            return this.$message.error(rs.data.msg);
          }
          this.fetchData();
          return this.$message.success(rs.data.msg);
        });
      });
    },
    updateSupply(row) {
      this.$router.push(`/home/supply/updatesupply/${row.sa_id}`);
    },
    supplyLog(row) {
      this.cur_id = row.sa_id;
      this.form.page = 1;
      this.logcurPage = 1;
      this.$http
        .post("/erp/supplyApply/getLog", { sa_id: row.sa_id })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data;
            this.logVisible = true;
          }
        });
    },
    // 切换页码
    handleCurrentChange2(val) {
      this.form.page = val;
      // this.tableLoading = true;
      this.$http
        .post("/erp/supplyApply/getLog", {
          sa_id: this.cur_id,
          page: val,
        })
        .then((res) => {
          setTimeout(() => {
            this.tableLoading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data;
          }
        });
    },
    // 导出按计划点货的商家
    exportPlanSupplyId(data) {
      this.$post("/erp/supply/exportExcelToPlanSupply").then((rs) => {
        window.open(apiBaseURL + rs.file);
      });
    },
    // 操作提前订阅开关
    handleShowApp(item) {
      const { sa_id: saId, show_app: showApp, fans_status: fansStatus } = item;
      let newShowAppStatus = "1";
      // 按钮开启状态 1  关闭 2
      if (showApp === "1") {
        // 关闭订阅
        newShowAppStatus = "2";
      } else {
        // 开启订阅
        newShowAppStatus = "1";
        // 已转移为档口粉丝 不可开启订阅
        if (fansStatus === "2") {
          this.$message.error("档口已经正式入驻，不可开启提前订阅");
          return;
        }
      }

      setShowApp({ sa_id: saId, show_app: newShowAppStatus }).then(() => {
        this.$message.success(
          newShowAppStatus === "1" ? "开启订阅设置成功" : "关闭订阅设置成功"
        );
        this.fetchData();
      });
    },
    // 操作提前订阅信息
    handleSupplyMsg(item = {}) {
      const { sa_id: saId, status } = item;
      this.$refs.supplyMessageRef.showSupplyDialog(saId || "", status);
    },
    // 导入批量建档申请成功
    importSupplyApplySuccess(data) {
      if (data.code !== 200) {
        const msg = data.msg.split("\r\n");
        const h = this.$createElement;
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message: h(
            "div",
            null,
            msg.map((item) => h("p", { style: "color: red" }, item))
          ),
        });
        return;
      }
      if (data.data.file) {
        window.open(apiBaseURL + data.data.file);
      } else {
        this.$message.success("导入成功");
      }
    },
    // 下载导入模板
    handleDownExportTemplate() {
      this.$post("/erp/SupplyApply/exportTemplate").then((rs) => {
        window.open(rs.file);
      });
    },
    handleViewVideo(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
.bottom-wrap {
  padding: 0px 6px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.bottom-wrap .sub-bottom {
  margin: 6px;
}
.message-error {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/pages/supplyapply/SupplyApplyList.vue